'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$l = require('./styles-0ce12bea.js');

var NavigationFooter = function (_a) {
    var onBackButtonPress = _a.onBackButtonPress, onForwardButtonPress = _a.onForwardButtonPress, backButtonDisabled = _a.backButtonDisabled, forwardButtonDisabled = _a.forwardButtonDisabled;
    return (React__default.createElement(styles$l.Container, null,
        React__default.createElement(styles$l.Icon, { icon: ['far', 'chevron-left'], disabled: backButtonDisabled, onClick: onBackButtonPress }),
        React__default.createElement(styles$l.Icon, { icon: ['far', 'chevron-right'], disabled: forwardButtonDisabled, onClick: onForwardButtonPress })));
};

exports.NavigationFooter = NavigationFooter;
